import { api } from "../services/Api";

export function useResetPassword() {
  const baseUrl = "/public/users";
  const baseUrlPassword = "/public/password-tokens";

  const sendEmailResetPassword = (email: string) => {
    return api.patch(`${baseUrl}/reset-password`, {
      email,
    });
  };

  const sendNewPassword = (token: string, data: Object) => {
    return api.patch(`${baseUrlPassword}/${token}`, data);
  };

  return {
    sendEmailResetPassword,
    sendNewPassword,
  };
}
